var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12.403L10 13.751V3.59796L16 2.25096V12.403ZM2 2.25096L8 3.59796V13.751L2 12.403V2.25096ZM17.625 0.218958C17.387 0.029958 17.077 -0.042042 16.78 0.024958L9 1.77296L1.22 0.024958C0.922 -0.043042 0.613 0.029958 0.375 0.218958C0.138 0.409958 0 0.696958 0 1.00096V13.203C0 13.671 0.324 14.076 0.78 14.178L8.78 15.976C8.854 15.993 8.927 16.001 9 16.001C9.073 16.001 9.146 15.993 9.22 15.976L17.22 14.178C17.676 14.076 18 13.671 18 13.203V1.00096C18 0.696958 17.862 0.409958 17.625 0.218958Z",
    fill: "#222B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.63bb4ed0fe9b90f7b3c992d0e75d0a11.svg";
export { ForwardRef as ReactComponent };